export default "__VITE_ASSET__35f64580__"